export default {
      id: "favorite-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#favorite-usage",
      toString: function () {
        return this.url;
      }
    }